import { Card } from "../../../../../components/Card";
import { Flex, Link, Text } from "@chakra-ui/react";

function ClimateActionPolicyOverview({ data }) {
  return (
    <Card>
      {data.policyComponent}
      <Flex marginTop="5" gap={2} alignItems="center" justifyContent="center">
        <Text>Source:</Text>
        <Link
          color={"esg_blue"}
          textDecoration="underline"
          isExternal
          href={"https://climateactiontracker.org/"}>
          https://climateactiontracker.org/
        </Link>
      </Flex>
    </Card>
  )
}

export default ClimateActionPolicyOverview;